<script lang="ts">
  let {
    value,
  }: {
    value: unknown
  } = $props()

  const label = $derived(String(value ?? ''))
  const variantClass = $derived(getVariantClass(label))

  function getVariantClass(input: string): string {
    const normalized = input.toLowerCase()

    if (/high|urgent|critical|blocked|overdue|failed|needs attention/.test(normalized)) {
      return 'widget-status-high'
    }

    if (/medium|monitor|pending|review|warning/.test(normalized)) {
      return 'widget-status-medium'
    }

    if (/low|info|open/.test(normalized)) {
      return 'widget-status-low'
    }

    if (/ok|good|ready|active|complete|completed|paid|passed|success/.test(normalized)) {
      return 'widget-status-ok'
    }

    return 'widget-status-low'
  }
</script>

<span class={`widget-status ${variantClass}`}>{label}</span>
